export default "https://cdn-static.gokick.com/assets/c736ccdc0086f37925b8733f1854c980393ad61e/images/systolic-smaller.187d7732286412ba55022faa30794641.svg";